export const state = {
  searchData: ''
}

export const mutations = {
  populateSearch(state, type) {
    state.searchData = type
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js